const toDigits = (value: string) => value.replace(/\D/g, '');

export const normalizeUkPhone = (value: string) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const digits = toDigits(raw);
  if (!digits) return '';

  let national = '';

  if (raw.startsWith('+')) {
    if (!digits.startsWith('44')) return '';
    national = digits.slice(2);
  } else if (digits.startsWith('0044')) {
    national = digits.slice(4);
  } else if (digits.startsWith('44') && raw.startsWith('44')) {
    national = digits.slice(2);
  } else if (digits.startsWith('0')) {
    national = digits.slice(1);
  } else {
    return '';
  }

  if (!national) return '';

  if (national.startsWith('0') && national.length === 11) {
    national = national.slice(1);
  }

  return `+44${national}`;
};

export const isValidUkPhone = (value: string) => {
  const normalized = normalizeUkPhone(value);
  if (!normalized) return false;
  const digits = toDigits(normalized);
  if (!digits.startsWith('44')) return false;
  const national = digits.slice(2);
  if (national.length !== 10) return false;
  if (national.startsWith('0')) return false;
  return true;
};
